import Dashboard from 'mpm-pages/dashboard';
import CessionCaptureCedant from 'mpm-pages/cessions-captures/cedant';
import CessionCaptureAcquereur from 'mpm-pages/cessions-captures/acquereur';
import CessionProduitCedant from 'mpm-pages/cessions-produits/cedant';
import CessionProduitAcquereur from 'mpm-pages/cessions-produits/acquereur';
import CessionExport from 'mpm-pages/cessions-exports';
import DeclarationVente from 'mpm-pages/declarations-ventes';
import Settings from './profil/parametre';
import Notifications from './profil/notifications';
import ResetPassword from './profil/reset-password';
const Pages = {
  Dashboard,
  CessionCapture: {
    Cedant: CessionCaptureCedant,
    Acequerur: CessionCaptureAcquereur,
  },
  CessionProduit: {
    Cedant: CessionProduitCedant,
    Acequerur: CessionProduitAcquereur,
  },
  CessionExport,
  DeclarationVente,
  Profile: {
    Settings,
    Notifications,
    ResetPassword,
  },
};

export default Pages;
